import { handleActions, combineActions } from "redux-actions";
import { AppState } from "../../../models";
import { UserAcionTypes } from "../../actions";

let userState: AppState.Me = {
  data: null,
  loading: false,
};

export const UserReducer = handleActions(
  {
    [combineActions(
      UserAcionTypes.loadMeStart,
      UserAcionTypes.loadMeSuccess,

      UserAcionTypes.clearMe
    ).toString()]: (state: AppState.Me, action: any) => {
      return { ...state, ...action.payload };
    },
  },
  userState
);
